export default __webpack_public_path__ + "img/2e6bd89331496f931f29df691b26fbea.png";